export default "__VITE_ASSET__CX893PLp__"